/**
 *
 * Profile
 *
 */
import { RootState } from 'controller/types';
import { SetupLoader } from 'core/components/SetupComponents/SetupLoader';
import { useAuth } from 'core/context/AuthContext/AuthContextProvider';
import { Language } from 'core/utils/types/modules/org';
import { useFetchLanguageList } from 'features/BranchSetup/hooks/useFetchLanguageList';

import React, { memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components/macro';
import { useUserSetupSlice } from 'features/UserSetup/slice';
import { Field, Form, Formik, FormikProps } from 'formik';

import { DropDown } from 'libs/DropDown';
import { Input } from 'core/components/Input';
import { Button } from 'core/components/Button';
import { PhotoUrl } from 'core/components/SetupComponents/PhotoUrl';
import { MobileComponent } from 'core/components/SetupComponents/MobileComponent';
import { useFetchCountryCode } from 'features/BranchSetup/hooks/useFetchCountryCode';
import {
  isRequiredEmail,
  isRequiredMobileNumber,
  isRequiredNumberGreaterThan0,
  isRequiredString,
} from 'core/utils/validationSchemas';
import * as Yup from 'yup';
import { error } from 'core/components/Notify';
import httpclient from 'libs/Axios';

interface Props {
  action?: string;
  values?: any;
}

const schema = Yup.object({
  LANGUAGE_ID: isRequiredNumberGreaterThan0(
    'Language is a required field',
    'Language is a required field',
  ),
  USER_NAME: Yup.string()
    .required('User Name is a required field.')
    .min(6, 'Username must be at least 6 characters long.')
    .matches(/^\S*$/, 'Username cannot contain spaces.'),



  FULL_NAME: isRequiredString('Full Name is a required field.'),
  EMAIL_ID: isRequiredEmail('Email is a required field.'),
  MOBILE_NUMBER: isRequiredMobileNumber('Mobile Number is a required field'),
});

export const Profile = memo((props: Props) => {
  const authData = useAuth();
  const dispatch = useDispatch();
  const { actions } = useUserSetupSlice();
  const state = useSelector((state: RootState) => state.userSetup);
  const [searchParams, setSearchParams] = useSearchParams();
  const [languageList, setlanguageList] = React.useState<Language[]>();
  const [countryList, setcountryList] = React.useState<any[]>();
  const [selectedFile, setSelectedFile] = useState<File[]>();
  const [actionChanged, setActionChanged] = React.useState(false);
  const [initialValues, setinitialValues] = React.useState<any>();
  const [usernameStatus, setUsernameStatus] = useState<string>('');
  const [counter, setcounter] = useState<number>(0);

  useFetchLanguageList(languageList, setlanguageList);
  useFetchCountryCode(countryList, setcountryList);

  React.useEffect(() => {
    if (props.action === 'update') {
      dispatch(
        actions.fetchUserSetupOneStart({
          URL: 'userDetail',
          ID: parseInt(searchParams.get('id') as string),
          ACADEMIC_YEAR_ID: authData?.SELECTED_ACADEMIC_YEAR
            .ACADEMIC_YEAR_ID as number,
          queryParamas: `?user_name=${authData?.USER_NAME}&user_id=${authData?.USER_ID}&user_role=${authData?.USER_ROLE_NAME}`,
        }),
      );
    }
  }, [
    actions,
    authData?.SELECTED_ACADEMIC_YEAR.ACADEMIC_YEAR_ID,
    authData?.USER_NAME,
    dispatch,
    props.action,
    searchParams,
    counter
  ]);

  React.useEffect(() => {
    if (props.action === 'update') {
      setActionChanged(!actionChanged);
    }
  }, [props.action]);

  React.useEffect(() => {
    if (state && state?.navigate && searchParams) {
      dispatch(actions.setNavigate(false));
    }
  }, [state, searchParams, setSearchParams, dispatch, actions]);

  React.useEffect(() => {
    if (state?.userData?.UserName) {
      setinitialValues({
        USER_ID: authData?.USER_ID,
        USER_ROLE: authData?.USER_ROLE_NAME,
        USER_NAME: state?.userData?.UserName,
        FULL_NAME: state?.userData?.FullName || '',
        COUNTRY_CODE: state?.userData?.CountryCode || '+91',
        MOBILE_NUMBER: state?.userData?.MobileNumber,
        EMAIL_ID: state?.userData?.EmailId,
        LANGUAGE_ID: state?.userData?.LanguageId,
        PHOTO_URL: state?.userData?.PhotoUrl,
      });
    }
  }, [state?.userData, dispatch, actions]);

  return Boolean(languageList && countryList && initialValues) ? (
    <Div>
      <Formik
        validationSchema={schema}
        initialValues={initialValues}
        // onSubmit={async values => {

        //   let value = { ...values };
        //   value = {
        //     ...value,
        //     FIRST_NAME: value?.FULL_NAME?.split(' ')?.[0] || '',
        //     LAST_NAME: value?.FULL_NAME?.split(' ')?.[1] || '',
        //   };
        //   delete value?.FULL_NAME;
        //   if (value?.USER_NAME === state?.userData?.UserName) {
        //     delete value?.USER_NAME;
        //   }
        //   setTimeout(() => {
        //     dispatch(
        //       actions.createUserSetupStart({
        //         data: value,
        //         action: props.action || 'save',
        //         URL: 'userDetail',
        //         message: props?.action
        //           ? 'Updated Successfully!'
        //           : 'Created Successfully!',
        //         authData: authData,
        //       }),
        //     );
        //   }, 2000)

        // }}

        onSubmit={async (values, { setSubmitting }) => {
          const temp = {
            ...authData,
            "USER_NAME": values?.USER_NAME,
            "NAME": values?.FULL_NAME,
            "MOBILE": values?.MOBILE_NUMBER,
            "EMAIL_ID": values?.EMAIL_ID,
            // "LANGUAGE_ID": 1,
            // "PHOTO_URL": ""
          }
          const isDirty = Object.keys(initialValues).some(
            key => initialValues[key] !== values[key],
          );

          if (isDirty) {
            const changedValues: any = {};
            changedValues['USER_ID'] = authData?.USER_ID;
            changedValues['USER_ROLE'] = authData?.USER_ROLE_NAME;

            Object.keys(values).forEach(key => {
              if (initialValues[key] !== values[key]) {
                changedValues[key] = values[key];
              }
            });

            if (Object.keys(changedValues).length > 0) {
              dispatch(
                actions.createUserSetupStart({
                  data: changedValues,
                  action: props.action || 'save',
                  URL: 'userDetail',
                  message: props?.action
                    ? 'Updated Successfully!'
                    : 'Created Successfully!',
                  authData: temp,
                }),
              );
              setcounter(counter + 1);
            }
          } else {
            error('No Values have been changed', true);
          }
          setSubmitting(false);
        }}
      >
        {(formikProps: FormikProps<any>) => (
          <Form>
            <div className="flex justify-between items-center gap-4">
              <div className="flex justify-center items-center w-[35%] border rounded-lg border-dotted border-gray-400 self-stretch">
                <Field name="PHOTO_URL">
                  {({ field, form, meta }) => (
                    <PhotoUrl
                      noBorder={true}
                      uploadToS3={!props.action ? true : false}
                      size="w-60 h-60"
                      selectedFile={selectedFile}
                      setSelectedFile={setSelectedFile}
                      URL={formikProps.values?.PHOTO_URL as string}
                      setField={(photoURL: string) => {
                        formikProps.setFieldValue('PHOTO_URL', photoURL);
                      }}
                      dest={'STAFF'}
                      id={authData?.STAFF_ROLE?.STAFF_ID}
                    />
                  )}
                </Field>
              </div>
              <div className="grid w-[75%]">
                <Field name="USER_NAME">
                  {({ field, form, meta }) => (
                    <>
                      <Input
                        type="text"
                        label="User Name"
                        value={field.value}
                        onChange={async (e) => {
                          field.onChange(e);
                          try {
                            const response = await httpclient().get(
                              `/auth/checkUsername?user_id=${authData?.USER_ID}&username=${e.target.value}`
                            );
                            setUsernameStatus(response?.data?.message);
                          } catch (error) {
                            console.error('Error checking username:', error);
                            setUsernameStatus('Error checking username');
                          }
                        }}
                        placeholder="Enter User Name"
                        name={field.name}
                        onBlur={field.onBlur}
                        error={meta.touched && meta.error}
                        message={meta.touched && meta.error}
                        required
                      />
                      {!meta.error && (
                        <>
                          {usernameStatus === 'Username available' && (
                            <span className="text-green-500 text-[1rem]">
                              Username is available
                            </span>
                          )}
                          {usernameStatus ===
                            'Username already taken. Please choose a different username.' && (
                              <span className="text-red-500 text-[1rem]">
                                Username already taken. Please choose a different
                                username.
                              </span>
                            )}
                          {usernameStatus === 'Username remains the same. No changes were made.' && (
                            <span className="text-orange-400 text-[1rem]">
                              Username remains the same. No changes were made.
                            </span>
                          )}
                        </>
                      )}
                    </>
                  )}
                </Field>

                <Field name="FULL_NAME">
                  {({ field, form, meta }) => (
                    <Input
                      type="text"
                      label="Full Name"
                      value={field.value}
                      onChange={field.onChange}
                      placeholder="Enter Full Name"
                      name={field.name}
                      onBlur={field.onBlur}
                      error={meta.touched && meta.error}
                      message={meta.touched && meta.error}
                      required
                    />
                  )}
                </Field>
                <MobileComponent
                  countryCodeName="COUNTRY_CODE"
                  numberName="MOBILE_NUMBER"
                  countryList={countryList as any}
                  inputValue={formikProps.values.MOBILE_NUMBER}
                  defaultCCValue={
                    countryList &&
                    (countryList.find(
                      item =>
                        item.COUNTRY_CODE ==
                        formikProps.initialValues.COUNTRY_CODE,
                    ) ||
                      countryList.find(item => item.COUNTRY_CODE == '+91'))
                  }
                  errorCC={
                    formikProps.touched.COUNTRY_CODE &&
                    formikProps.errors.COUNTRY_CODE
                  }
                  messageCC={
                    formikProps.touched.COUNTRY_CODE &&
                    formikProps.errors.COUNTRY_CODE
                  }
                  errorMobile={
                    formikProps.touched.MOBILE_NUMBER &&
                    formikProps.errors.MOBILE_NUMBER
                  }
                  messageMobile={
                    formikProps.touched.MOBILE_NUMBER &&
                    formikProps.errors.MOBILE_NUMBER
                  }
                />

                <Field name="EMAIL_ID">
                  {({ field, form, meta }) => (
                    <Input
                      type="email"
                      label="Email ID"
                      value={field.value}
                      onChange={field.onChange}
                      placeholder="Enter Email ID"
                      name={field.name}
                      onBlur={field.onBlur}
                      error={meta.touched && meta.error}
                      message={meta.touched && meta.error}
                      required
                    />
                  )}
                </Field>
                <Field name="LANGUAGE_ID">
                  {({ field, form, meta }) => (
                    <DropDown
                      getOptionValue={(option: Language) => option.LANGUAGE_ID}
                      getOptionLabel={(option: Language) =>
                        `${option.NAME.toUpperCase()}`
                      }
                      options={languageList as any}
                      placeholder="Select Preferred Language"
                      onChange={(item: Language) => {
                        form.setFieldValue('LANGUAGE_ID', item.LANGUAGE_ID);
                      }}
                      menuPlacement='top'
                      label={'Preferred Language'}
                      defaultValue={
                        languageList
                          ? languageList.find(
                            item =>
                              item.LANGUAGE_ID ===
                              form.initialValues.LANGUAGE_ID,
                          )
                          : ''
                      }
                      name="LANGUAGE_ID"
                      onBlur={formikProps.handleBlur}
                      error={
                        formikProps.touched.LANGUAGE_ID &&
                          formikProps.errors.LANGUAGE_ID
                          ? true
                          : false
                      }
                      message={
                        formikProps.touched.LANGUAGE_ID &&
                          formikProps.errors.LANGUAGE_ID
                          ? formikProps.errors.LANGUAGE_ID
                          : ''
                      }
                      required
                    />
                  )}
                </Field>
              </div>
            </div>
            <div className="mt-4">
              <Button
                isPreviousYearCheckNotRequied={true}
                submit
                type="primary"
                label={'Save'}
                disabled={usernameStatus ===
                  'Username already taken. Please choose a different username.'}
              />
            </div>
          </Form>
        )}
      </Formik>
    </Div>
  ) : (
    <SetupLoader />
  );
});

const Div = styled.div``;
